/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ role: NonNullable<unknown> }} Team_Manager_Import_Role_FallbackInputs */



/**
* | output |
* | --- |
* | "\"{role}\" isn't a role, so the default role is used" |
*
* @param {Team_Manager_Import_Role_FallbackInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_import_role_fallback = /** @type {((inputs: Team_Manager_Import_Role_FallbackInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Import_Role_FallbackInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`« ${i?.role} » n'est pas un rôle ; le rôle par défaut est utilisé`)
	if (locale === "de") return /** @type {LocalizedString} */ (`„${i?.role}“ ist keine Rolle, daher wird die Standardrolle verwendet`)
	if (locale === "it") return /** @type {LocalizedString} */ (`"${i?.role}" non è un ruolo, quindi viene usato il ruolo predefinito`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`«${i?.role}» — не роль, поэтому используется роль по умолчанию`)
	if (locale === "es") return /** @type {LocalizedString} */ (`"${i?.role}" no es un rol, así que se usa el rol predeterminado`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`“${i?.role}”不是有效角色，将使用默认角色`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`「${i?.role}」は役割ではないため、既定の役割を使用します`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`"${i?.role}" कोई भूमिका नहीं है, इसलिए डिफ़ॉल्ट भूमिका इस्तेमाल होगी`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`"${i?.role}" não é uma função, por isso é usada a função predefinida`)
	return /** @type {LocalizedString} */ (`"${i?.role}" isn't a role, so the default role is used`)
});